module.exports = __webpack_public_path__ + "static/media/betsInCurrentRoom_2.c7bc764b.mp3";